import React, { useEffect } from "react";
import { FaArrowRight, FaClipboard, FaClipboardCheck, FaClone, FaCopy } from "react-icons/fa";
import logo from "../Untitled.svg";
import { Project,moreProject } from "../Data";
import { useState } from "react";
import { Link } from "react-router-dom";
import WOW from "wowjs";

const Projects = () => {
	const [isCopy, setIsCopy] = useState(false);
   const [MoreProjects, setMoreProjects] = useState(false);
	useEffect(() => {
		new WOW.WOW({
			live: false,
		}).init();
	});
	useEffect(() => {
		const time = setTimeout(() => {
			setIsCopy(false);
			return () => {
				clearTimeout(time);
			};
		}, 2000);
	}, [isCopy]);
	return (
		<div id="projects">
			<div className="projects">
				<h2>projects</h2>

				{MoreProjects
					? moreProject.map((project) => {
							const { id, skills, projectName, img, className, text, url } = project;
							return (
								<a href={url} target="_blank">
								<div className={`project ${className} wow animate__animated animate__fadeIn${className}`} data-wow-duration="1s" data-wow-delay="1s" key={id}>
									<div className="project-img-container">
										<img src={img} alt="" />
										<div className="blur"></div>
									</div>
									<div className="project-write ">
										<h4>{projectName}</h4>
										<div className="info">{text}</div>
										<ul className="skill">
											{skills.map((skill) => {
												return <li key={id}>{skill}</li>;
											})}
										</ul>
										<div className="url">
											
												view
											
											<FaClone
												onClick={(e) => {
													e.preventDefault();
													navigator.clipboard.writeText(url);
													setIsCopy(true);
												}}
											/>
										</div>
									</div>
								</div>
								</a>
							);
					  })
					: Project.map((project) => {
							const { id, skills, projectName, img, className, text, url } = project;
							return (
								<a href={url} target="_blank">
									<div className={`project ${className} wow animate__animated animate__fadeIn${className}`} data-wow-duration="1s" data-wow-delay="1s" key={id}>
										<div className="project-img-container">
											<img src={img} alt="" />
											<div className="blur"></div>
										</div>
										<div className="project-write ">
											<h4>{projectName}</h4>
											<div className="info">{text}</div>
											<ul className="skill">
												{skills.map((skill) => {
													return <li key={id}>{skill}</li>;
												})}
											</ul>
											<div className="url">
												view
												<FaClone
													onClick={(e) => {
														e.preventDefault();
														navigator.clipboard.writeText(url);
														setIsCopy(true);
													}}
												/>
											</div>
										</div>
									</div>
								</a>
							);
					  })}
				
					<button className="btn" onClick={()=>{setMoreProjects(!MoreProjects);}}>{MoreProjects ?'show less': 'show more'}</button>
				
			</div>

			{isCopy && <div className="copy-message" onClick={(e)=>{e.preventDefault()}}>URL copied to clipboard</div>}
		</div>
	);
};

export default Projects;
